module.exports = __webpack_public_path__ + "media/high_school_students/cta_stacked-439d1c67.png";